// Import react
import React, { useState, useEffect, useRef, } from "react";

import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { primarySkillsSearch, topFiveProfiles } from "../redux/actions/actions";

import { getAllBoards, createBoard } from "../redux/actions/boardActions";

// Import supabase configuration
import supabase from "../config/supabase";

// Import custom components
import ProfileCard from "../components/profile/profile";
import Header from "../components/header/boardHeader";
import Search from "../components/search/search";
import Button from "../components/button/button";
import Accordion from "../components/accordion/accordion";
import Checkboxs from "../components/checkbox/checkbox";
import Select from "../components/dropdown/dropdown";
import MuiSelect from "@mui/material/Select";
import ExperienceSlider from "../components/slider/expSlider";
import Slide from "../components/slider/slide";
import Pagination from "../components/pagination/pagination";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import MenuItem from "@mui/material/MenuItem";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MuiButton from "@mui/material/Button";
import Skeleton from "react-loading-skeleton";
// Import data
import { countriesList } from "../asstes/countries";
import { skillsLists } from "../asstes/skills";
import { industriesList } from "../asstes/industries";
import { timezonesList } from "../asstes/timezones";
import { Oval } from "react-loader-spinner";
import { Buffer } from "buffer";
import { nanoid } from "nanoid";

// create new board
import BoardDialogue from "../components/dialogue/boardDialogue";

export default function SearchPage() {
  const { data } = useSelector((state) => state.profile);
  const initialState = useSelector((state) => state.boards);

  const dispatch = useDispatch();

  const [profiles, setProfiles] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchFlag, setSearchFlag] = useState(false);
  const [exp, setExp] = useState([0, 20]);
  const [languageProficiency, setLanguageProficiency] = useState(1);
  const [skills, setSkills] = useState([]);
  const [skillArray, setSkillArray] = useState([]);
  const [location, setLocation] = useState([]);
  const [isLocation, setIsLocation] = useState(false);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState("");
  const [industry, setIndustry] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [hourlyRate, setHourlyRate] = useState([
    { id: "1", val: "Any hourly rate", checked: false },
    { id: "2", val: "$10 and Below", checked: false },
    { id: "3", val: "$10 to $15", checked: false },
    { id: "4", val: "$15 to $25", checked: false },
    { id: "5", val: "$25 to $40", checked: false },
    { id: "6", val: "$40 to $60", checked: false },
    { id: "7", val: "$60 to $100", checked: false },
    { id: "8", val: "$100 and above", checked: false },
  ]);
  const [industryList, setIndustryList] = useState([]);
  const [hourlyRateValue, setHourlyRateValue] = useState("");
  const [jobType, setJobType] = useState([
    { id: "1", val: "Hourly", checked: false },
    { id: "2", val: "Part Time", checked: false },
    { id: "3", val: "Full Time", checked: false },
  ]);
  const [jobTypeValue, setJobTypeValue] = useState("");
  const [timeZone, setTimeZone] = useState([]);
  const [timeZoneValue, setTimeZoneValue] = useState("");
  const [availability, setAvailability] = useState([
    { id: "1", val: "Immediate", checked: false },
    { id: "2", val: "Within 1 week", checked: false },
    { id: "3", val: "Within 2 weeks", checked: false },
    { id: "4", val: "Within 1 month", checked: false },
    { id: "5", val: "Within 2 months", checked: false },
    { id: "6", val: "After 2 month", checked: false },
  ]);
  const [availabilityValue, setAvailabilityValue] = useState("");
  const [overlaping, setOverlaping] = useState([
    { id: "1", val: "Flexible", checked: false },
    { id: "2", val: "1 hour", checked: false },
    { id: "3", val: "2 hour", checked: false },
    { id: "4", val: "3 hour", checked: false },
    { id: "5", val: "4 hour", checked: false },
    { id: "6", val: "5 hour", checked: false },
    { id: "7", val: "6 hour", checked: false },
    { id: "8", val: "7 hour", checked: false },
    { id: "9", val: "Fully overlapped", checked: false },
  ]);
  const [overlapingDisabled, setoverlapingDisabled] = useState(false);
  const [overlapingValue, setOverlapingValue] = useState("");
  const [searchedSkills, setSearchedSkills] = useState([]);
  const [searchedValue, setSearchedValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([
    { id: 0, filter: "skill_Level", checked: false },
    { id: 1, filter: "exp", checked: false },
    { id: 2, filter: "location", checked: false },
    { id: 3, filter: "job_type", checked: false },
    { id: 4, filter: "industry", checked: false },
    { id: 5, filter: "rate", checked: false },
    { id: 6, filter: "availability", checked: false },
    { id: 7, filter: "langProf", checked: false },
    { id: 8, filter: "timezone", checked: false },
    { id: 9, filter: "overlapingHours", checked: false },
    { id: 10, filter: "state", checked: false },
  ]);
  const [searchedItem, setSearchedItem] = useState("");
  const [list, setList] = useState([]);
  const [suggested, setSuggested] = useState(true);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [bestProfiles, setBestProfiles] = useState([]);
  const [partialProfiles, setPartialProfiles] = useState([]);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [profilesAddedInBoard, setProfilesAddedInBoard] = useState([]);
  const [showButton, setShowButton] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [boards, setBoards] = useState([]);
  const [selectedBoard, setSelectedBaord] = useState("");
  const [boardId, setBaordId] = useState("");
  const [saveButtonStyle, setSaveButtonStyle] = useState("w-32 bg-pink-1");
  const [bestCurrentPage, setBestCurrentPage] = useState(1);
  const [partialCurrentPage, setPartialCurrentPage] = useState(1);
  const [bestPostsPerPage] = useState(9);
  const [partialPostsPerPage] = useState(4);
  const [bestCurrentPosts, setBestCurrentPosts] = useState();
  const [partialCurrentPosts, setPartialCurrentPosts] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [sortBy, setSortBy] = useState([
    { id: "1", value: "Name Ascending", label: "Name Ascending", checked: false },
    { id: "2", value: "Name Descending", label: "Name Descending", checked: false },
    { id: "3", value: "Experience Ascending", label: "Experience Ascending", checked: false },
    { id: "4", value: "Experience Descending", label: "Experience Descending", checked: false },
  ]);
  const [showSkeleton, setShowSkeleton] = useState(true)
  const [selectedSort, setSelectedSort] =useState("");
  // add new board
  const [createBoardFlag, setCreateBoardFlag] = useState(false);
  const [board, setBoard] = useState({});
  // window.onload = function () {
  //   localStorage.removeItem("searchedObject");
  //   localStorage.removeItem("searchedItem");
  //   localStorage.removeItem("inputField");
  // };
  const pageRefConf = (event) => {
    localStorage.removeItem("searchedObject");
    localStorage.removeItem("searchedItem");
    localStorage.removeItem("inputField");
    localStorage.removeItem("skillsWithLevel");
  };
  useEffect(() => {
    document.title = "Search";
    dispatch(getAllBoards());
    window.addEventListener("beforeunload", pageRefConf);
    window.addEventListener("beforeunload", setShowSkeleton(true));
    setTimeout( () => {
      window.addEventListener("beforeunload", setShowSkeleton(false));
    }, 2000)
    return () => {
      window.removeEventListener("beforeunload", pageRefConf);
    };
  }, []);

  useEffect(() => {
    let fetchLocalStorage = localStorage.getItem("searchedItem");
    if (!fetchLocalStorage) {
      getTopProfiles();
      clearFilter("clearAll");
    } else {
      setSearchFlag(true);
    }
  }, [localStorage.getItem("searchedItem")]);

  useEffect(() => {
    initialState.sort(function(a, b) {
      var c = new Date(a.created_at);
      var d = new Date(b.created_at);
      return d-c;
    });
    setBoards(initialState);
    if( initialState.length > 0 ){
      if(!selectedBoard || selectedBoard== "Add board")
      setSelectedBaord(initialState[0].name) 
    }
    else{
      setSelectedBaord("Add board");
    } 
  }, [initialState]);

  useEffect(() => {
    skillFilter();
  }, [appliedFilters, searchedSkills]);

  useEffect(() => {
    if (timeZoneValue.text === "Flexible") {
      setoverlapingDisabled(true);
      var overlapped = overlaping;
      overlapped = overlapped.map((r) => ({ ...r, checked: false }));
      setOverlapingValue("");
      setOverlaping(overlapped);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[9].checked = false;
        return newstate;
      });
    } else {
      setoverlapingDisabled(false);
    }
  }, [timeZoneValue]);

  useEffect(async () => {
    setProfiles(data);
    setFilteredProfiles(data);
    // Craete new list
    var countryList = countriesList.map((c) => ({
      value: c.country,
      label: c.country,
    }));
    var stateList = countriesList.map((c) => ({ ...c, label: c.states }));
    var skillList = skillsLists.map((c) => ({ ...c, label: c.value }));
    var industryList = industriesList.map((c) => ({ ...c, label: c.value }));
    var lists = [...skillList, ...industryList, ...countryList];
    var timezoneList = timezonesList.map((c) => ({ ...c, label: c.text }));
    setList(lists);
    setSkillList(skillList);
    setCountryList(countryList);
    setStatesList(stateList);
    setIndustryList(industryList);
    setTimeZone(timezoneList);
  }, []);

  useEffect(() => {
    setProfiles(data);
    setFilteredProfiles(data);
    changeState();
  }, [data]);

  useEffect(() => {
    // get current posts
    getBestCurrentPost();
    getPartialCurrentPost();
  }, [filteredProfiles, bestCurrentPage, partialCurrentPage, bestProfiles]);

  const getTopProfiles = () => {

    dispatch(topFiveProfiles())
      .then(() => {})
      .catch(() => {
        console.log("Error");
      });
  };

  // create board
  const closeModal = () => {
    setCreateBoardFlag(!createBoardFlag);
    boards.length > 0 &&  setSelectedBaord(boards[0].name);
  };

  const createNewBoard = (value) => {
    setSelectedBaord("");
    setCreateBoardFlag(!createBoardFlag);
    dispatch(createBoard({ name: value }));
  };

  const searchTextFunc = (val) => {
    if (val) {
      var text = val.indexOf(" ") >= 0 ? val.replace(/[ ,]+/g, ",") : val;
      var query = text.replace(/,/gi, "|");
      var arr = query.split("");
      var newArr = arr.slice(-1) == "|" ? arr.filter((d) => d != "|") : arr;
      var tempString = newArr.toString();
      tempString = tempString.replace(/,/gi, "");
      dispatch(primarySkillsSearch(tempString));
    }
  };

  const getBestCurrentPost = () => {
    const indexOfLastPost = bestPostsPerPage * bestCurrentPage;
    const indexOfFirstPost = indexOfLastPost - bestPostsPerPage;
    setBestCurrentPosts(bestProfiles.slice(indexOfFirstPost, indexOfLastPost));
  };

  const getPartialCurrentPost = () => {
    const indexOfLastPost = partialPostsPerPage * partialCurrentPage;
    const indexOfFirstPost = indexOfLastPost - partialPostsPerPage;
    setPartialCurrentPosts(
      partialProfiles.slice(indexOfFirstPost, indexOfLastPost)
    );
  };

  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth', block: "center" });

  // change page
  const bestPaginate = (pageNumber) => {
    setBestCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  const partialPaginate = (pageNumber) => {
    setPartialCurrentPage(pageNumber);
    executeScroll();
  };

  // return true if in range, otherwise false
  function rateInRange(x, min, max) {
    if (min == max) {
      // For 100 and above
      return x >= min;
    } else {
      return x > min && x <= max;
    }
  }

  const changeState = (val) => {
    var searched = localStorage.getItem("searchedItem") || "";
    var availableSkills = localStorage.getItem("skillsWithLevel") || "";
    var searchedObject = localStorage.getItem("searchedObject") || "";
    var input = localStorage.getItem("inputField") || "";
    // setSuggested(input && JSON.parse(input));
    // searchedObject && setSearchedObject(JSON.parse(searchedObject));
    var tempSkills = [];
    searched = searched.split(":");
    setSearchText(searched[1]);
    setSearchedItem(searched[0]);
    if (searched[0] === "Skills") {
      setSearchFlag(true);
      var temp = searched[1].split(",");
      var a = eval(availableSkills);
      if (a?.length || temp?.length) {
        var afterRemove = temp;
        if (a?.length) {
          a.forEach((skill) => {
            tempSkills.push(skill);
            afterRemove = afterRemove.filter((index) => index != skill.skill);
          });
        }
        if (afterRemove?.length) {
          afterRemove.forEach((skill) => {
            tempSkills.push({ skill: skill.trim(), level: 1 });
          });
        }
      } else {
        tempSkills.push({ skill: searched[1].trim(), level: 1 });
      }
    } else if (searched[0] === "Filters") {
      setSearchFlag(true);
      setSearchedValue(searched);
    }
    setSkillArray(temp);
    setSearchedSkills(tempSkills);
    setAppliedFilters((prev) => {
      var newstate = [...prev];
      newstate[0].checked = true;
      return newstate;
    });
  };

  const skillFilter = (value) => {
    setShowSkeleton(true);
    var best = [];
    var partial = [];
    // loop over all the data available on frontend
    data.forEach((profile) => {
      var count = 0;
      var totalFilters = appliedFilters.filter(
        (value) => value.checked === true
      ).length;
      //loop over all applied filters
      appliedFilters.forEach((index) => {
        if (index.filter === "skill_Level" && index.checked === true) {
          var skillLength = searchedSkills.length;
          var i = 0;
          searchedSkills.forEach((filters) => {
            for (
              let keyIndex = 0;
              keyIndex < profile.skill_level.length;
              keyIndex++
            ) {
              const skill = profile.skill_level[keyIndex];
              const databaseSkillValue = skill.skill.toLowerCase();
              const filterSkillValue = filters.skill.toLowerCase();
              if (
                (databaseSkillValue.indexOf(filterSkillValue) > -1 ||
                  databaseSkillValue.includes(filterSkillValue)) &&
                skill.level >= filters.level - 1
              ) {
                i++;
                break;
              }
            }
            // profile.skill_level.forEach((skill) => {

            // });
          });
          if (skillLength == i) {
            count = count + 1;
          }
        } else if (index.filter === "location" && index.checked === true) {
          count += locationFilter(profile, location);
        } else if (index.filter === "state" && index.checked === true) {
          count += stateFilter(profile, stateValue);
        } else if (index.filter === "job_type" && index.checked === true) {
          count = jobTypeFilter(count, profile, jobTypeValue);
        } else if (index.filter === "industry" && index.checked === true) {
          count += industryFilter(profile, industry);
        } else if (index.filter === "exp" && index.checked === true) {
          count += experienceFilter(profile, exp);
        } else if (index.filter === "langProf" && index.checked === true) {
          count += languageFilter(profile, languageProficiency);
        } else if (index.filter === "availability" && index.checked === true) {
          count += availabilityFilter(profile, availabilityValue);
        } else if (index.filter === "timezone" && index.checked === true) {
          count += timezoneFilter(profile, timeZoneValue);
        } else if (
          index.filter === "overlapingHours" &&
          index.checked === true
        ) {
          count += overlappingHoursFilter(profile, overlapingValue);
        } else if (index.filter === "rate" && index.checked === true) {
          if (hourlyRateValue !== "Any hourly rate") {
            count = hourlyRateFilter(count, profile, hourlyRateValue);
          }
        }
      });

      totalFilters == count ? best.push(profile) : partial.push(profile);
    });
    // console.log("best", best);
    setBestProfiles(best);
    // console.log("partial", partial.length);
    setPartialProfiles(partial);
    setFilteredProfiles([...best, ...partial]);
    setTimeout( () => {
      setShowSkeleton(false);
    },[1000])
  };

  const jobTypeFilter = (count, profile, filter) => {
    filter.forEach((index) => {
      if (profile.contract_status.toLowerCase() === index.val.toLowerCase()) {
        count += 1;
      }
    });
    return count;
  };

  const stateFilter = (profile, filter) => {
    if (profile.states.toLowerCase() === filter.value.toLowerCase()) {
      return 1;
    } else {
      return 0;
    }
  };

  const industryFilter = (profile, filter) => {
    var tempIndustry = profile.industries.toLowerCase();
    if (tempIndustry.includes(filter.value.toLowerCase())) {
      return 1;
    } else {
      return 0;
    }
  };

  const timezoneFilter = (profile, filter) => {
    if (profile.timezone === filter.text) {
      return 1;
    } else {
      return 0;
    }
  };

  const locationFilter = (profile, filter) => {
    var location = profile.location.toLowerCase();
    if (location.includes(filter.value.toLowerCase())) {
      return 1;
    } else {
      return 0;
    }
  };

  const experienceFilter = (profile, filter) => {
    if (filter[0] <= profile.exp && profile.exp <= filter[1]) {
      return 1;
    } else {
      return 0;
    }
  };

  const languageFilter = (profile, filter) => {
    if (profile.language_proficiency >= filter) {
      return 1;
    } else {
      return 0;
    }
  };

  const overlappingHoursFilter = (profile, filter) => {
    var value = Number(filter.slice(0, 1));
    if (value) {
      if (profile.overlapping_hours >= value) {
        return 1;
      }
    } else {
      if (filter == "Flexible" && profile.overlapping_hours === 0) {
        return 1;
      } else if (profile.overlapping_hours === 8) {
        return 1;
      } else {
        return 0;
      }
    }
  };

  const availabilityFilter = (profile, filter) => {
    var value = 0;
    var max = false;
    if (filter === "Immediate") {
      value = 0;
    } else if (filter === "Within 1 week") {
      value += 7;
    } else if (filter === "Within 2 weeks") {
      value += 14;
    } else if (filter === "Within 1 month") {
      value += 30;
    } else if (filter === "Within 2 months") {
      value += 60;
    } else {
      max = true;
    }
    if (max) {
      if (profile.availability >= 60) {
        return 1;
      } else {
        return 0;
      }
    } else {
      if (profile.availability <= value) {
        return 1;
      } else {
        return 0;
      }
    }
  };

  const hourlyRateFilter = (count, profile, rate) => {
    rate.forEach((index) => {
      var min = Number(index.val.slice(1, 4));
      var max = 0;
      if (min == 10) {
        var temp = parseInt(index.val.slice(-2));
        if (isNaN(temp)) {
          if (rateInRange(profile.expected_hourly_rate, 1, min)) {
            count = count + 1;
          }
        } else {
          if (rateInRange(profile.expected_hourly_rate, min, temp)) {
            count = count + 1;
          }
        }
      } else if (min == 100) {
        min = Number(index.val.slice(1, 4));
        if (rateInRange(profile.expected_hourly_rate, min, min)) {
          count = count + 1;
        }
      } else {
        max = Number(index.val.slice(8, index.val.length));
        if (rateInRange(profile.expected_hourly_rate, min, max)) {
          count = count + 1;
        }
      }
    });
    return count;
  };

  const removeDuplicates = (data) => {
    return [...new Set(data)];
  };

  // Set fields
  const onChangeEvent = (value, name, type, action) => {
    if (name == "exp") {
      setExp(value);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[1].checked = true;
        return newstate;
      });
    } else if (name == "langProf") {
      setLanguageProficiency(value);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[7].checked = true;
        return newstate;
      });
    } else if (name == "skills") {
      setShowSkeleton(true);
      setSkills(value);
      var skillsWithLevel = searchedSkills || [];
      if (action?.action === "remove-value" || action?.action === "pop-value") {
        clearFilter("clearOneSkill", action.removedValue.value);
        skillsWithLevel = searchedSkills?.filter(
          (d) => d.skill != action.removedValue.value
        );
        var array = value.map((s) => s.label);
        setSearchText(array.toString());
      }
      if (value.length > 0) {
        localStorage.setItem(
          "skillsWithLevel",
          JSON.stringify(skillsWithLevel)
        );
        var array = value.map((s) => s.label);
        let getLocalStoageItem = localStorage.getItem("searchedItem");
        getLocalStoageItem = getLocalStoageItem?.split(":");
        var searched = getLocalStoageItem ? getLocalStoageItem[1] : "";
        var result =
          searched && getLocalStoageItem[0] == "Skills"
            ? searched.concat(",", array.toString())
            : array.toString();
        var arr = result.split(",");
        var afterRemove = removeDuplicates(arr);
        setSearchText(afterRemove.toString());
        localStorage.setItem(
          "searchedItem",
          `Skills:${afterRemove.toString()}`
        );
        searchTextFunc(afterRemove.toString());
        if (skillArray) {
          setSkillArray((prev) => {
            var newVal = [...prev];
            newVal.push(value[0]?.value);
            return newVal;
          });
        } else {
          var tempVal = [];
          tempVal.push(value[0]?.value);
          setSkillArray(tempVal);
        }
      }
    } else if (name == "location") {
      setLocation(value);
      setIsLocation(true);
      setStateValue('');
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[2].checked = true;
        newstate[10].checked = false;
        return newstate;
      });
      // locationFilter(value);
    } else if (name == "state") {
      setStateValue(value);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[10].checked = true;
        return newstate;
      });
    } else if (name == "industry") {
      setIndustry(value);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[4].checked = true;
        return newstate;
      });
    } else if (name == "rate") {
      var rates = hourlyRate;
      var index = rates.findIndex((r) => r.id == value.id);
      rates[index].checked = value.checked;
      var allCheckedValues = rates.filter((data) => data.checked == true);
      setHourlyRateValue(allCheckedValues);
      setHourlyRate(rates);
      allCheckedValues.length > 0
        ? setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[5].checked = true;
            return newstate;
          })
        : setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[5].checked = false;
            return newstate;
          });
    } else if (name == "job") {
      var types = jobType;
      var index = types.findIndex((r) => r.id == value.id);
      types[index].checked = value.checked;
      var allCheckedValues = types.filter((data) => data.checked == true);
      setJobTypeValue(allCheckedValues);
      setJobType(types);
      allCheckedValues.length > 0
        ? setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[3].checked = true;
            return newstate;
          })
        : setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[3].checked = false;
            return newstate;
          });
      // jobTypeFilter(types[index].val)
    } else if (name == "timezone") {
      setTimeZoneValue(value);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[8].checked = true;
        return newstate;
      });
    } else if (name == "availability") {
      var avail = availability;
      avail = avail.map((r) => ({ ...r, checked: false }));
      var index = avail.findIndex((r) => r.id == value.id);
      avail[index].checked = value.checked;
      setAvailabilityValue(avail[index].val);
      setAvailability(avail);
      value.checked
        ? setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[6].checked = true;
            return newstate;
          })
        : setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[6].checked = false;
            return newstate;
          });
    } else if (name == "overlaping") {
      var overlapped = overlaping;
      overlapped = overlapped.map((r) => ({ ...r, checked: false }));
      var index = overlapped.findIndex((r) => r.id == value.id);
      overlapped[index].checked = value.checked;
      setOverlapingValue(overlapped[index].val);
      setOverlaping(overlapped);
      value.checked
        ? setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[9].checked = true;
            return newstate;
          })
        : setAppliedFilters((prev) => {
            var newstate = [...prev];
            newstate[9].checked = false;
            return newstate;
          });
    }
  };

  const searchProfiles = (data, searchObj) => {
    var searchedItem = localStorage.getItem("searchedItem").split(":");
    if (!searchObj?.length && !searchedItem[1]?.length > 0) {
      localStorage.removeItem("searchedItem");
      localStorage.removeItem("searchedObject");
      changeState();
      return;
    }
    // if (!searchedItem?.length) {
    //   localStorage.removeItem("searchedItem");
    //   changeState();
    //   return;
    // }
    // changeLoader("start");
    // Replace space with commas
    var text = data.indexOf(" ") >= 0 ? data.replace(/[ ,]+/g, ",") : data;
    var textArr = text.indexOf(",") >= 0 ? text.split(",") : [];
    var rawTextArray = data.indexOf(",") >= 0 ? data.split(",") : data;

    if (text || textArr.length) {
      // check if value is skill/industry
      var query = text.replace(/,/gi, "|");
      localStorage.setItem(
        "searchedObject",
        searchObj ? JSON.stringify(searchObj) : null
      );
      localStorage.setItem("inputField", JSON.stringify(suggested));
      dispatch(primarySkillsSearch(query))
        .then((res) => {
          localStorage.removeItem("searchedItem");
          if (res.length > 0) {
            localStorage.setItem(
              "searchedItem",
              `Skills:${rawTextArray.length > 0 ? rawTextArray : text}`
            );
            changeState();
          }
        })
        .catch(() => {
          console.log("Error");
        });
    }
    // setTimeout(() => {
    //   changeLoader("end");
    // }, 2000);
  };

  const clearFilter = (name, val) => {
    if (name === "clearAll") {
      setShowSkeleton(true);
      // localStorage.removeItem("searchedItem");
      // localStorage.removeItem("searchedObject");
      localStorage.removeItem("skillsWithLevel");
      setSearchFlag(false);
      // getTopProfiles();
      setSearchText("");
      // setSearchedObject('');
      setExp([0, 20]);
      setLanguageProficiency(1);
      setSkills([]);
      setSkillArray([]);
      setLocation([]);
      setIsLocation(false);
      setStateValue("");
      setIndustry([]);
      setHourlyRate([
        { id: "1", val: "Any hourly rate", checked: false },
        { id: "2", val: "$10 and Below", checked: false },
        { id: "3", val: "$10 to $15", checked: false },
        { id: "4", val: "$15 to $25", checked: false },
        { id: "5", val: "$25 to $40", checked: false },
        { id: "6", val: "$40 to $60", checked: false },
        { id: "7", val: "$60 to $100", checked: false },
        { id: "8", val: "$100 and above", checked: false },
      ]);
      setHourlyRateValue("");
      setJobType([
        { id: "1", val: "Hourly", checked: false },
        { id: "2", val: "Part Time", checked: false },
        { id: "3", val: "Full Time", checked: false },
      ]);
      setJobTypeValue("");
      setTimeZoneValue("");
      setAvailability([
        { id: "1", val: "Immediate", checked: false },
        { id: "2", val: "Within 1 week", checked: false },
        { id: "3", val: "Within 2 weeks", checked: false },
        { id: "4", val: "Within 1 month", checked: false },
        { id: "5", val: "Within 2 months", checked: false },
        { id: "6", val: "After 2 month", checked: false },
      ]);
      setAvailabilityValue("");
      setOverlaping([
        { id: "1", val: "Flexible", checked: false },
        { id: "2", val: "1 hour", checked: false },
        { id: "3", val: "2 hour", checked: false },
        { id: "4", val: "3 hour", checked: false },
        { id: "5", val: "4 hour", checked: false },
        { id: "6", val: "5 hour", checked: false },
        { id: "7", val: "6 hour", checked: false },
        { id: "8", val: "7 hour", checked: false },
        { id: "9", val: "Fully overlapped", checked: false },
      ]);
      setOverlapingValue("");
      setoverlapingDisabled(false);
      setSearchedSkills([]);
      setSearchedValue("");
      setAppliedFilters([
        { id: 0, filter: "skill_Level", checked: false },
        { id: 1, filter: "exp", checked: false },
        { id: 2, filter: "location", checked: false },
        { id: 3, filter: "job_type", checked: false },
        { id: 4, filter: "industry", checked: false },
        { id: 5, filter: "rate", checked: false },
        { id: 6, filter: "availability", checked: false },
        { id: 7, filter: "langProf", checked: false },
        { id: 8, filter: "timezone", checked: false },
        { id: 9, filter: "overlapingHours", checked: false },
        { id: 10, filter: "state", checked: false },
      ]);
      setSearchedItem("");
      setSelectedSort("");
      setBestCurrentPage(1);
      setPartialCurrentPage(1);
    } else if (name === "clearOneSkill") {
      setShowSkeleton(true);
      var remove = searchedSkills.filter((index) => index.skill !== val);
      var temp = remove.map((index) => index.skill);
      localStorage.setItem("skillsWithLevel", JSON.stringify(remove));
      var removeSearchedObject = localStorage.getItem("searchedObject");
      removeSearchedObject = eval(removeSearchedObject);
      if (removeSearchedObject?.length) {
        removeSearchedObject = removeSearchedObject.filter(
          (index) => index.value !== val
        );
      }
      localStorage.setItem("searchedItem", `Skills:${temp.toString()}`);
      removeSearchedObject?.length
        ? searchProfiles(temp.toString(), removeSearchedObject)
        : searchProfiles(temp.toString());
      var afterRemoveFromSkills = skills?.filter((index) => index.value != val);
      setSkills(afterRemoveFromSkills);
      // localStorage.setItem("searchedItem", `skills:${temp}`);
      // setSearchedSkills(remove);
      // setSkillArray(temp);
      // skillFilter();
      // localStorage.setItem('searchedObject', JSON.stringify(temp));
      // localStorage.setItem('inputField', JSON.stringify(suggested));
    } else if (name === "clear_skills") {
      setShowSkeleton(true);
      setSkills([]);
      var remove = searchedSkills;
      skills.forEach((value) => {
        remove = remove.filter((index) => index.skill !== value.value);
      });
      localStorage.setItem("skillsWithLevel", JSON.stringify(remove));
      var temp = remove.map((index) => index.skill);
      var searchedObject = remove.map((index) => {
        return { value: index.skill, label: index.skill };
      });
      searchProfiles(temp.toString(), searchedObject);
    } else if (name === "clear_rate") {
      var rates = hourlyRate;
      rates = rates.map((r) => ({ ...r, checked: false }));
      setHourlyRateValue("");
      setHourlyRate(rates);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[5].checked = false;
        return newstate;
      });
    } else if (name === "clear_exp") {
      setExp([0, 20]);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[1].checked = false;
        return newstate;
      });
    } else if (name === "clear_location") {
      setLocation([]);
      setIsLocation(false);
      setStateValue("");
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[2].checked = false;
        return newstate;
      });
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[10].checked = false;
        return newstate;
      });
    } else if (name === "clear_industry") {
      setIndustry([]);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[4].checked = false;
        return newstate;
      });
    } else if (name === "clear_job") {
      var types = jobType;
      types = types.map((r) => ({ ...r, checked: false }));
      setJobTypeValue("");
      setJobType(types);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[3].checked = false;
        return newstate;
      });
    } else if (name === "clear_availability") {
      var avail = availability;
      avail = avail.map((r) => ({ ...r, checked: false }));
      setAvailabilityValue("");
      setAvailability(avail);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[6].checked = false;
        return newstate;
      });
    } else if (name === "clear_languageProficiency") {
      setLanguageProficiency(1);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[7].checked = false;
        return newstate;
      });
    } else if (name === "clear_timezone") {
      setTimeZoneValue("");
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[8].checked = false;
        return newstate;
      });
    } else if (name === "clear_overlapping") {
      var overlapped = overlaping;
      overlapped = overlapped.map((r) => ({ ...r, checked: false }));
      setOverlapingValue("");
      setOverlaping(overlapped);
      setAppliedFilters((prev) => {
        var newstate = [...prev];
        newstate[9].checked = false;
        return newstate;
      });
    }
  };

  const selectProfile = (id, profile) => {
    // Get copy of profiles
    var profiles = [];
    profiles = profile == "Best" ? [...bestProfiles] : [...partialProfiles];

    var index = profiles.findIndex((item) => item.id === id);

    // Udpate state
    profiles[index].checked = !profiles[index].checked;
    // Set state
    profile == "Best"
      ? setBestProfiles(profiles)
      : setPartialProfiles(profiles);
    // Show and hide button
    if (
      profiles.some((profile) => profile.checked == true) ||
      bestProfiles.some((profile) => profile.checked == true) ||
      partialProfiles.some((profile) => profile.checked == true)
    ) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  const getAllBoardProfiles = async (boardId) => {
    const { data, error } = await supabase
      .from("board_profiles")
      .select("*")
      .match({ board: boardId });

    if (data && data.length > 0) {
      var dataObject = {
        profiles: data[0].profiles,
        alreadyBoardAvailable: true,
      };
      return dataObject;
    } else {
      var dataObject = {
        profiles: [],
        alreadyBoardAvailable: false,
      };
      return dataObject;
    }
  };

  const getScreenShot =  async(Id) => {
    var id = Buffer.from(Id,
      "utf-8"
    ).toString("base64");

   await axios
   .get(`https://shot.screenshotapi.net/screenshot?token=4RRW077-CTRM39S-KYT9CEG-SEXV7FG&url=https://ats-search.netlify.app/sharedProfiles?id=${id}&width=1040&height=750&delay=5000`)
   .then( async(response) => {  
    const Image = response.data.screenshot;
    // setScreenShotImage(Image);
    const { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles_screenshot: Image })
        .match({ board: Id });

   })
   .catch(function (error) {
     console.log("error in taking screenshot", error);
   });
  };

  // Function for profile addition
  const addSelection = async () => {
    setShowLoader(true);
    // Get board id
    var boardId = boards.find((b) => b.name == selectedBoard).id;
    setBaordId(boardId);

    // Get a copy of profiles
    var profiles = [...bestProfiles, ...partialProfiles];

    var dataObject = await getAllBoardProfiles(boardId);

    var resultedProfiles = dataObject.profiles;
    var available = dataObject.alreadyBoardAvailable;
    resultedProfiles = resultedProfiles || [];
    var selected = [];

    // Loop over profiles
    profiles.forEach((profile) => {
      // Find the selected profile and check if already in selected board
      if (profile.checked) {
        var included = false;
        resultedProfiles &&
          resultedProfiles.forEach((rp) => {
            if (rp.id === profile.id) {
              included = true;
            }
          });
        // Add to selection
        !included &&
          selected.push({
            id: profile.id,
            status: "New",
            message: "",
            meetingTime: "",
            endMeetingTime: "",
            rate: profile.expected_hourly_rate,
            paymentFrequency: "Hourly"
          });
      }
    });

    setSelectedProfiles(selected);

    var all_profiles = [...resultedProfiles, ...selected];
    setProfilesAddedInBoard(all_profiles);

    if (resultedProfiles.length <= 0 && !available) {
      let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

      const { data, error } = await supabase
        .from("board_profiles")
        .insert({ board: boardId, profiles: all_profiles, masked_url: masked_url });

      if (data && data.length) {
        setSaveButtonStyle("w-32 bg-black-1");
        setShowMessage(true);
        setMessage("Profile is added successfully.");
        setTimeout(function () {
          setShowButton(false);
          setSaveButtonStyle("w-32 bg-pink-1");
          var unCheckedProfiles = [...filteredProfiles];
          unCheckedProfiles = unCheckedProfiles.map((p) => ({
            ...p,
            checked: false,
          }));

          var unCheckBestProfiles = [...bestProfiles];
          unCheckBestProfiles = unCheckBestProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          var unCheckPartialProfiles = [...partialProfiles];
          unCheckPartialProfiles = unCheckPartialProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          setBestProfiles(unCheckBestProfiles);
          setPartialProfiles(unCheckPartialProfiles);
          setFilteredProfiles(unCheckedProfiles);
        }, 3000);
        getScreenShot(boardId);
      }
    } else if (all_profiles.length - resultedProfiles.length > 0) {
      // Get all clients with same board id
      var { data, error } = await supabase
      .from("board_clients_invitation")
      .select("*")
      .match({ board: boardId });
      
      const clients_invitations = data;

      if(clients_invitations && clients_invitations.length > 0){
        for(let i =0; i< clients_invitations.length ;i++){
          let client_profiles = clients_invitations[i].profiles;
          // Update profiles
          client_profiles = [...client_profiles,...selected];

          // Update profiles in client table
          const { data, error } = await supabase
          .from("board_clients_invitation")
          .update({ profiles: client_profiles })
          .match({ board: boardId , id : clients_invitations[i].id});
        }
      }

      // Update profiles in board profile table
      var { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles: all_profiles })
        .match({ board: boardId });

      if (data && data.length) {
        setSaveButtonStyle("w-32 bg-black-1");
        setShowMessage(true);
        setMessage("Profile is added successfully.");
        setTimeout(function () {
          setShowButton(false);
          setSaveButtonStyle("w-32 bg-pink-1");
          var unCheckedProfiles = [...filteredProfiles];
          unCheckedProfiles = unCheckedProfiles.map((p) => ({
            ...p,
            checked: false,
          }));

          var unCheckBestProfiles = [...bestProfiles];
          unCheckBestProfiles = unCheckBestProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          var unCheckPartialProfiles = [...partialProfiles];
          unCheckPartialProfiles = unCheckPartialProfiles.map((p) => ({
            ...p,
            checked: false,
          }));
          setBestProfiles(unCheckBestProfiles);
          setPartialProfiles(unCheckPartialProfiles);
          setFilteredProfiles(unCheckedProfiles);
        }, 3000);
        if((resultedProfiles.length) < 3){
          getScreenShot(boardId);
        }
      }
    } else {
      setShowMessage(true);
      setMessage("Profile already exists in board.");
      setTimeout(function () {
        setShowMessage(false);
      }, 3000);
    }
    setShowLoader(false);
  };

  const undoProfileAddition = async () => {
    setShowMessage(false);
    // Delete profiles
    // Get a copy of all profiles in board
    var profiles = profilesAddedInBoard;

    // Get copy of currently selected profiles
    var selected_profiles = selectedProfiles;

    var selected = [];
    profiles.forEach((profile) => {
      var check = false;
      // Find the selected profile and push to selected
      selected_profiles.forEach((p) => {
        if (p.id == profile.id) {
          check = true;
        }
      });
      !check && selected.push(profile);
    });

    const { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: selected })
      .match({ board: boardId });

    var unCheckedProfiles = [...filteredProfiles];
    unCheckedProfiles = unCheckedProfiles.map((p) => ({
      ...p,
      checked: false,
    }));

    var unCheckBestProfiles = [...bestProfiles];
    unCheckBestProfiles = unCheckBestProfiles.map((p) => ({
      ...p,
      checked: false,
    }));

    var unCheckPartialProfiles = [...partialProfiles];
    unCheckPartialProfiles = unCheckPartialProfiles.map((p) => ({
      ...p,
      checked: false,
    }));
    setPartialProfiles(unCheckPartialProfiles);
    setBestProfiles(unCheckBestProfiles);
    setFilteredProfiles(unCheckedProfiles);

    setShowButton(false);
    setMessage("Profile has been undo successfully.");

      setTimeout(function () {
        setShowMessage(true);
      }, 500);
      setTimeout(function () {
        setShowMessage(false);
      }, 2000);
  };

  // Change board
  const changeBoard = (event) => {
    setSelectedBaord(event.target.value);
  };

  const StyledInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      "&:focus": {
        borderRadius: 4,
        borderColor: "",
        boxShadow: "",
      },
    },
  }));

  const action = (
    <React.Fragment>
      {saveButtonStyle !== "w-32 bg-pink-1" && (
        <MuiButton
          color="secondary"
          size="small"
          onClick={() => undoProfileAddition()}
        >
          UNDO
        </MuiButton>
      )}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setShowMessage(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const changeLoader = (check) => {
    check == "start" ? setShowLoader(true) : setShowLoader(false);
  };

  const getChange = (value) => {
    var bestprofile = [...bestProfiles];
    setSelectedSort(value);
    if(value.value === 'Name Ascending') {
      bestprofile = bestprofile.sort( (a,b) => {
        let fa = a.full_name.toLowerCase(),
        fb = b.full_name.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;

      })
      setBestProfiles(bestprofile)
    }
    else if(value.value === 'Name Descending') {
      bestprofile = bestprofile.sort( (a,b) => {
        let fa = a.full_name.toLowerCase(),
        fb = b.full_name.toLowerCase();

        if (fa < fb) {
          return 1;
        }
        if (fa > fb) {
            return -1;
        }
        return 0;

      })
      setBestProfiles(bestprofile);
    }
    else if(value.value === 'Experience Ascending'){
      bestprofile = bestprofile.sort( (a,b) => a.exp - b.exp);
      setBestProfiles(bestprofile);
    }
    else if(value.value === 'Experience Descending'){
      bestprofile = bestprofile.sort( (a,b) => b.exp - a.exp);
      setBestProfiles(bestprofile);
    }
    const indexOfLastPost = bestPostsPerPage * bestCurrentPage;
    const indexOfFirstPost = indexOfLastPost - bestPostsPerPage;
    setBestCurrentPosts(bestprofile.slice(indexOfFirstPost, indexOfLastPost));
  }
    let skeletonRepeated = 5;

  return (
    <>
      <div className="w-full h-auto">
        {/* Header component */}
        <div className="sticky top-0 z-50">
          <Header current="home" />
        </div>
        {showLoader && (
        <div className="fixed flex items-center bg-white-1 justify-center z-30 w-full h-full top-0">
            {/* Add backdrop */}
            
          <div className={`relative flex`}>
            <Oval
                color="white"
                secondaryColor="grey"
                height="40"
                width="60"
              />
              <div className="flex items-center">Hold Tight-just getting this page ready.</div>
          </div>
        </div>
        )}

        {/* create board */}
        <div className="w-full bg-white-2">
          <BoardDialogue
            open={createBoardFlag}
            handleModal={createNewBoard}
            board={board}
            closeModal={closeModal}
          />
        </div>
        
        <Snackbar
          open={showMessage}
          onClose={() => setShowMessage(false)}
          autoHideDuration={3000}
          message={message}
          action={action}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />
        {/* Show profiles */}
        <div className="grid grid-cols-12 bg-white-2 ">
          {/* Filters */}
          <div className="z-10 col-span-3 sticky top-20 overflow-y-scroll scrollbar h-screen bg-white-1">
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-12">
                <Card sx={{ minWidth: 315 }}>
                  <CardContent className="mb-20">
                    {/* Applied filters */}
                    {(searchedSkills.length ||
                      localStorage.getItem("searchedItem") ||
                      searchedValue) && (
                      <div className="col-span-12 mt-6 mb-2">
                        <div className="h-30 flex justify-between my-3">
                          <div className="text-lg font-semibold">
                            Applied filters
                          </div>
                          <Button
                            name="clearAll"
                            buttonType="link-2"
                            value="Clear All"
                            onClick={(e) => {
                              clearFilter("clearAll");
                              getTopProfiles();
                              pageRefConf();
                            }}
                          />
                        </div>
                
                        {searchedSkills.length
                          ? searchedSkills.map((skill, index) => (
                              <div key={index}>
                                <div className="flex justify-between">
                                  <h2 className="font-bold">{skill.skill}</h2>
                                  <svg
                                    className="hover:cursor-pointer"
                                    onClick={(e) => {
                                      clearFilter("clearOneSkill", skill.skill);
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                                  </svg>
                                </div>
                                <div className="flex mr-10 ml-5">
                                  <div className="grow">
                                    <Slide
                                      key={index}
                                      skill={skill}
                                      value={skill.level}
                                      index={index}
                                      change={(data) => {
                                        setSearchedSkills(data);
                                        skillFilter(skill);
                                        setAppliedFilters((prev) => {
                                          var newstate = [...prev];
                                          newstate[0].checked = true;
                                          return newstate;
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))
                          : localStorage.getItem("searchedItem")
                          ? localStorage.getItem("searchedItem")
                          : searchedValue}
                      </div>
                    )}
                
                    {/* All filters */}
                    <div className="col-span-11 mt-6">
                      <div className="text-lg font-semibold mb-2">
                        Advanced Filters
                      </div>
                      <div>
                        {/* Skills */}
                        <Accordion title="Skills">
                          <div className="flex flex-col w-full">
                            {skills.length ? (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_skills"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_skills");
                                  }}
                                />
                              </div>
                            ) : null}
                            <Select
                              name="skills"
                              value={skills}
                              multi={true}
                              placeholder="Skills"
                              getChange={(e, action) =>
                                onChangeEvent(e, "skills", suggested, action)
                              }
                              options={skillList}
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Hourly rate */}
                        <Accordion title="Hourly Rate">
                          <div className="flex flex-col w-full">
                            {appliedFilters[5].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_rate"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_rate");
                                  }}
                                />
                              </div>
                            )}
                            <Checkboxs
                              lists={hourlyRate}
                              onChange={(e) => onChangeEvent(e, "rate", suggested)}
                              filter="rate"
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Experience */}
                        <Accordion title="Experience in years">
                          {/* <Slider onChange={(e) => onChangeEvent(e, "exp",suggested)} value={exp} filter="exp"/> */}
                          {/* <Slider onChange={(e) => onChangeEvent(e, "exp")} value={exp} filter="exp"/> */}
                          <div className="flex flex-col w-full">
                            {appliedFilters[1].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_exp"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_exp");
                                  }}
                                />
                              </div>
                            )}
                            <ExperienceSlider
                              onChange={(e) => onChangeEvent(e, "exp", suggested)}
                              value={exp}
                              filter="exp"
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Location */}
                        <Accordion title="Location">
                          <div className="flex flex-col w-full">
                            {appliedFilters[2].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_location"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_location");
                                  }}
                                />
                              </div>
                            )}
                            <Select
                              name="Location"
                              value={location}
                              placeholder="Country"
                              getChange={(e) =>
                                onChangeEvent(e, "location", suggested)
                              }
                              options={countryList}
                              isLocation={true}
                              statesList={statesList}
                              setStates={(data) => setStates(data)}
                            />
                            {isLocation ? (
                              <Select
                                name="state"
                                value={stateValue}
                                placeholder="state"
                                getChange={(e) =>
                                  onChangeEvent(e, "state", suggested)
                                }
                                options={states}
                              />
                            ) : null}
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Industry */}
                        <Accordion title="Industry">
                          <div className="flex flex-col w-full">
                            {appliedFilters[4].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_industry"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_industry");
                                  }}
                                />
                              </div>
                            )}
                            <Select
                              name="industry"
                              value={industry}
                              placeholder="Industry"
                              getChange={(e) =>
                                onChangeEvent(e, "industry", suggested)
                              }
                              options={industryList}
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Job type */}
                        <Accordion title="Job type">
                          <div className="flex flex-col w-full">
                            {appliedFilters[3].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_job"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_job");
                                  }}
                                />
                              </div>
                            )}
                            <Checkboxs
                              lists={jobType}
                              onChange={(e) => {
                                onChangeEvent(e, "job", suggested);
                              }}
                              filter="job"
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Availability */}
                        <Accordion title="Availability">
                          <div className="flex flex-col w-full">
                            {appliedFilters[6].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_availability"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_availability");
                                  }}
                                />
                              </div>
                            )}
                            <Checkboxs
                              lists={availability}
                              onChange={(e) =>
                                onChangeEvent(e, "availability", suggested)
                              }
                              filter="availability"
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Language proficiency */}
                        <Accordion title="Language proficiency">
                          {/* <Slider filter="langProf" onChange={(e) => onChangeEvent(e, "langProf")} value={languageProficiency}/> */}
                          <div className="flex flex-col w-full">
                            {appliedFilters[7].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_languageProficiency"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_languageProficiency");
                                  }}
                                />
                              </div>
                            )}
                            <div className="grow mx-5">
                              <Slide
                                filter="langProf"
                                onChange={(e) =>
                                  onChangeEvent(e, "langProf", suggested)
                                }
                                value={languageProficiency}
                              />
                            </div>
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Time zone */}
                        <Accordion title="Required Time Zone">
                          <div className="flex flex-col w-full">
                            {appliedFilters[8].checked && (
                              <div className="flex justify-end">
                                <Button
                                  name="clear_timezone"
                                  buttonType="link-2"
                                  value="clear"
                                  className="mb-3"
                                  onClick={(e) => {
                                    clearFilter("clear_timezone");
                                  }}
                                />
                              </div>
                            )}
                            <Select
                              name="timezone"
                              value={timeZoneValue}
                              placeholder="Timezone"
                              getChange={(e) =>
                                onChangeEvent(e, "timezone", suggested)
                              }
                              options={timeZone}
                            />
                          </div>
                        </Accordion>
                      </div>
                
                      <div className="mt-6">
                        {/* Overlapping Hours */}
                        {overlapingDisabled ? null : (
                          <Accordion title="Overlapping Hours">
                            <div className="flex flex-col w-full">
                              {appliedFilters[9].checked && (
                                <div className="flex justify-end">
                                  <Button
                                    name="clear_overlapping"
                                    buttonType="link-2"
                                    value="clear"
                                    className="mb-3"
                                    onClick={(e) => {
                                      clearFilter("clear_overlapping");
                                    }}
                                  />
                                </div>
                              )}
                              <Checkboxs
                                lists={overlaping}
                                onChange={(e) =>
                                  onChangeEvent(e, "overlaping", suggested)
                                }
                                filter="overlaping"
                              />
                            </div>
                          </Accordion>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>

          {/* Profiles */}
          <div className="grid grid-col-2 col-span-9 z-0">
            {/* Search component */}
            <div className="grid sticky top-20 bg-blue-6 h-36">
              <div className="py-5 px-10 mt-2">
                <Search
                  name="search"
                  isMulti={true}
                  changeState={changeState}
                  clearFilter={clearFilter}
                  isSearchPage={true}
                  showLoader={(value) => changeLoader(value)}
                />
              </div>
              <div className="grid grid-cols-12 -mt-1">
                <div className="col-span-6 flex justify-start px-10  ml-2 mb-4">
                  {showButton && (
                    <div className="flex space-x-2">
                      {saveButtonStyle == "w-32 bg-pink-1" ? (
                        <MuiSelect
                          labelId="boards"
                          id="boards"
                          label={selectedBoard}
                          value={selectedBoard}
                          onChange={changeBoard}
                          input={<StyledInput />}
                        >
                          { boards.map((b) => (
                            <MenuItem key={b.name} value={b.name}>
                              {b.name}
                            </MenuItem>
                          ))}
                          <MenuItem
                             sx={{
                              color: '#4C8BFF',
                            }}
                            value="Add board"
                            onClick={() => setCreateBoardFlag(!createBoardFlag)}
                          >
                            Add board
                          </MenuItem>
                        </MuiSelect>
                      ) : (
                        <p className="flex items-center mr-8 text-base font-semibold">
                          {selectedBoard}
                        </p>
                      )}
                
                      {boards.length > 0 && (
                        <Button
                          value={
                            saveButtonStyle == "w-32 bg-pink-1" ? "Save" : "Saved"
                          }
                          buttonType="search"
                          className={`${saveButtonStyle} ${(selectedBoard == "" || selectedBoard.length <= 0) && "pointer-events-none"} ` }
                          onClick={() => addSelection()}
                        />
                      )}
                    </div>
                  )}
                </div>
                { searchFlag && 
                  <div className="col-span-6 flex justify-end px-10 ml-2 mb-4">
                    <div className="flex space-x-2">
                      <Select
                        name="Sort By"
                        value={selectedSort}
                        placeholder="Sort By:"
                        getChange={(e) => getChange(e)}
                        options={sortBy}
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
            {showSkeleton ? (
                [...Array(skeletonRepeated)].map((e , index) => (
                <div className="-z-10 rounded-2xl bg-white-1 shadow-clientCard h-60 grid grid-cols-12 gap-3 p-6 box-border mb-3 m-6" key={index}>
                  <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex mt-5 relative">
                  <Skeleton height={90} width={90} />
                  </div>
                  <div  className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3">
                    {/*For name and email */}
                    <div className="col-span-12">
                      <div>
                        <Skeleton height={25} width={150} />
                      </div>
                      <div>
                        <Skeleton height={20} width={190} />
                      </div>
                    </div>
                    {/* For Location and experience */}
                    <div className="col-span-12 lg:col-span-5">
                      {/* Location */}
                      <div className=" flex items-center">
                        <Skeleton height={18} width={92} className="mr-1" />
                      </div>
                      {/* experience */}
                      <div className="flex items-center">
                        <Skeleton height={25} width={92} className="mr-1" />
                      </div>
                    </div>
                    {/* For timezone and hourly rate */}
                    <div className="col-span-12 lg:col-span-4">
                      {/* Timezone */}
                      <div className="flex items-center">
                        <Skeleton height={18} width={92} className="mr-1" />
                      </div>
                      {/* hourly rate */}
                      <div className="flex items-center">
                        <Skeleton height={25} width={92} className="mr-1" />
                      </div>
                    </div>
                    <div className="hidden md:block col-span-3">
                      <div className="-ml-6">
                      <Skeleton height={43} width={210} />
                      </div>
                    </div>
                    <div className="hidden md:block col-span-2"></div>
                    <div className="col-span-12 md:col-span-10 flex flex-wrap">
                      <div className="-ml-32">
                        <Skeleton height={38} width={400} />
                      </div>
                    </div>
                  </div>
                </div>
                ))
              ):
            filteredProfiles ? (
              filteredProfiles.length > 0 ? (
                // <div className="overflow-y-scroll scrollbar">
                (<div className="grid pt-5 mx-10 -z-20">
                  <div className="flex justify-between">
                    <div className="text-3xl font-bold mb-5">
                      {searchFlag ? "Best Profiles" : "Top Profiles"}
                    </div>
                  </div>

                  {bestProfiles.length > 0 && searchFlag && (
                    <div className="m-3">
                      Total Profiles: {bestProfiles.length}
                    </div>
                  )}

                  {/* Render profiles here */}
                  {bestCurrentPosts.length > 0 ? (
                    bestCurrentPosts.map((profile, index) => (
                      <ProfileCard
                        key={index}
                        id={index}
                        data={profile}
                        filter={searchedItem}
                        searched={searchFlag}
                        onChange={selectProfile}
                        searchedSkills={skillArray}
                        // skills = {searchedSkills}
                        checkProfile="Best"
                      />
                    ))
                  ) : (
                    <div className="text-center my-5">
                      There are no exact matched profiles with selected criteria
                      but we have some suggested profiles with same skill set
                      bellow.
                    </div>
                  )}

                  {bestCurrentPosts.length > 0 && searchFlag && (
                    <div>
                      <Pagination
                        totalPosts={bestProfiles.length}
                        postsPerPage={bestPostsPerPage}
                        paginate={bestPaginate}
                      />
                    </div>
                  )}

                  {partialCurrentPosts.length > 0 && (
                    <div>
                      <div className="text-3xl font-bold my-5">
                        Suggested Profiles
                      </div>
                      <div ref={myRef} className="m-3">
                        Total Profiles: {partialProfiles.length}
                      </div>
                    </div>
                  )}

                  {/* Render profiles here */}
                  {partialCurrentPosts.map((profile, index) => (
                    <ProfileCard
                      key={index}
                      id={index}
                      data={profile}
                      filter={searchedItem}
                      searched={true}
                      onChange={selectProfile}
                      searchedSkills={skillArray}
                      // skillsAll = {searchedSkills}
                      checkProfile="Partial"
                    />
                  ))}
                  {partialCurrentPosts.length > 0 && (
                    <Pagination
                      totalPosts={partialProfiles.length}
                      postsPerPage={partialPostsPerPage}
                      paginate={partialPaginate}
                    />
                  )}
                </div>)
              ) : (
                // </div>
                searchFlag && (
                  <div className="grid content-center h-screen">
                    <span className="text-center">
                      YOUR SEARCH DID NOT MATCH ANY PROFILES
                    </span>
                  </div>
                )
              )
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
